import { Stack } from '@mui/material'
import React, { FC } from 'react'
import { EmphasizedNumber, IconButton, Icons } from 'utoniq-ui'

import { config } from '@/config'
import { useRouter } from '@/core'

export type PointDisplayPurchaseProps = {
  point: number | string
  onClick?: () => void
}

export const PointDisplayPurchase: FC<PointDisplayPurchaseProps> = ({
  point,
  onClick,
}) => {
  const { routerPages } = useRouter()
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      direction="row"
      sx={{
        position: 'relative',
        bgcolor: 'grey.100',
        borderRadius: 3,
        height: 20,
        pl: 7,
        pr: config.modules.prepaidPoint?.chargeable ? 7 : 4,
      }}
    >
      <Icons.Point
        fontSize="medium"
        sx={{ position: 'absolute', left: -2, top: -2 }}
      />
      <EmphasizedNumber variant="subtitle1">{point}</EmphasizedNumber>
      {!!config.modules.prepaidPoint?.chargeable && (
        <IconButton.Plus
          size="small"
          href={routerPages.PrepaidPointCharge}
          onClick={event => {
            if (onClick) {
              event.preventDefault()
              onClick()
            }
          }}
          color="white"
          bgcolor="primary.main"
          sx={{
            width: 24,
            height: 24,
            position: 'absolute',
            right: 0,
            svg: {
              width: 15,
              height: 15,
            },
          }}
        />
      )}
    </Stack>
  )
}
